<template>
  <div class="home">
    <div class="monitor">
      <img class="monitor-img" src="@/assets/img/home/monitor.png" />
      <div class="real-time" @click="toggle">
        实时监测
        <div class="span">
          <img :src="hide ? arrowTop: arrowBottom" />
        </div>
      </div>
      <div class="data-analysis" v-show="hide" @click="analysis">数据分析</div>
      <span class="time">{{time}}</span>
    </div>
    <div class="screen">
      <ul>
        <li @click="selectDevice">
          选择监测场所
          <div class="content">
            <span>{{equipment}}</span>>
          </div>
        </li>
      </ul>
      <transition name="my">
      <vue-pickers v-if="show" @select="select" @close="show=false" :selsectData="regionList"></vue-pickers>
      </transition>
    </div>
    <div class="pm">
      <div class="pm-list">
        <span class="line line-one"></span>
        <span class="title">PM2.5 和 PM10</span>
        <div class="bg-img bg-img-one">
          <div class="xg-content">
            <div class="title1 mt10">
              PM2.5：{{obj!=null?obj.pm25:''}}
            </div>
            <div class="title2 mt5">
              控制上限  75 ug/m³
            </div>
            <div class="title1 mt5">PM10：{{obj!=null?obj.pm10:''}}</div>
            <div class="title2 mt5">
              控制上限  150 ug/m³
            </div>
          </div>
          <!-- <div class="content">
            <span>PM2.5：</span>
            <span>{{obj!=null?obj.pm25:''}}</span>
            <span class="ml40">PM10：</span>
            <span>{{obj!=null?obj.pm10:''}}</span>
          </div> -->
        </div>
      </div>
      <div class="pm-list">
        <span class="line line-two"></span>
        <span class="title">风速/风力</span>
        <div class="bg-img bg-img-two">
          <div class="xg-content">
            <div class="title1 mt30">
              风速：{{obj!=null?obj.windSpeed:''}} m/s
            </div>
            <div class="title1 mt15">风力：{{obj!=null?obj.windPower:''}}</div>
          </div>
        </div>
      </div>
      <div class="pm-list">
        <span class="line line-three"></span>
        <span class="title">风向</span>
        <div class="bg-img bg-img-three">
          <div class="xg-content">
            <div class="title1 mt40">{{obj!=null?obj.windDirection:''}}</div>
          </div>
        </div>
      </div>
      <div class="pm-list">
        <span class="line line-four"></span>
        <span class="title">温度/湿度</span>
        <div class="bg-img bg-img-four">
          <div class="xg-content">
            <div class="title1 mt33">
              温度：{{obj!=null?obj.envTemperature:''}} ℃ 
            </div>
            <div class="title1 mt10">湿度：{{obj!=null?obj.envHumidity:''}} %RH</div>
          </div>
        </div>
      </div>
      <div class="pm-list">
        <span class="line line-five"></span>
        <span class="title">光照度</span>
        <div class="bg-img bg-img-five">
          <div class="xg-content">
            <div class="title1 mt33">
              光照度：
            </div>
            <div class="title1 mt10">{{obj!=null?obj.illuminance:''}} lux</div>
          </div>
        </div>
      </div>
      <div class="pm-list">
        <span class="line line-six"></span>
        <span class="title">噪声</span>
        <div class="bg-img bg-img-six">
          <div class="xg-content">
            <div class="title1 mt33">
              噪声：
            </div>
            <div class="title1 mt10">{{obj!=null?obj.noise:''}} dbm</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs";
const arrowTop = require("@/assets/img/home/arrow-top.png");
const arrowBottom = require("@/assets/img/home/arrow-bottom.png");
import { getNewestRealTimeData, initScreenData } from "@/api/index";
import vuePickers from "@/layouts/vuePickers";
export default {
  data() {
    return {
      obj: {},
      hide: false,
      arrowTop,
      arrowBottom,
      time: "",
      timer: "", //定义一个定时器的变量
      dateTime: "",
      show: false, //下拉框显示隐藏
      region: "",
      equipment: "",
      id: '',
      // envHumidity: '',
      regionList: [] //下拉选择项
    };
  },
  components: {
    vuePickers
  },
  created() {
    const query = Qs.parse(location.search.substring(1))
    this.id = query.id;
    console.log(this.id)
    // 获取数据
    var _this = this;
    this.timer = setInterval(function() {
      var myDate = new Date();
      myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      myDate.getMonth(); //获取当前月份(0-11,0代表1月)
      myDate.getDate(); //获取当前日(1-31)
      myDate.getHours(); //获取当前小时数(0-23)
      myDate.getMinutes(); //获取当前分钟数(0-59)
      myDate.getSeconds(); //获取当前秒数(0-59)
      var myMonth = parseInt(myDate.getMonth()) + 1;
      var myHours = myDate.getHours().toString();
      var myMinutes = myDate.getMinutes().toString();
      var mySeconds = myDate.getSeconds().toString();
      if (myHours.length == 1) {
        myHours = "0" + myHours;
      }
      if (myMinutes.length == 1) {
        myMinutes = "0" + myMinutes;
      }
      if (mySeconds.length == 1) {
        mySeconds = "0" + mySeconds;
      }
      _this.time =
        myDate.getFullYear() +
        "-" +
        myMonth +
        "-" +
        myDate.getDate() +
        " " +
        myHours +
        ":" +
        myMinutes +
        ":" +
        mySeconds;
    }, 1000);

    this.dateTime = setInterval(function() {
      _this.getDate();
    }, 5000);
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.dateTime) {
      clearInterval(this.dateTime); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  computed: {},
  mounted() {
    this.getInitScreenData();
  },
  methods: {
    //初始化筛选框
    getInitScreenData() {
      initScreenData({ engineeringConfigId: this.id }).then(res => {
        console.log(res);
        if (res) {
          this.regionList = res.screenData;
          this.region = res.screenData[0].sn;
          this.equipment = res.screenData[0].equipment;
          this.getDate();
        } else {
          this.regionList = [];
        }
      });
    },
    toggle() {
      this.hide = !this.hide;
    },
    analysis() {
      this.$router.push({
        path: "analysis",
        query: { sn: this.region }
      });
      this.hide = false;
    },
    getDate() {
      let parms = {
        sn: this.region
      };
      getNewestRealTimeData(parms)
        .then(res => {
          this.obj = res.resultData;
          // if (this.obj !== null) {
          //   // this.envHumidity = this.obj.envHumidity.toFixed(2)
          // } else {
          //   this.envHumidity = ''
          // }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //选择设备
    selectDevice() {
      this.show = true;
    },
    //选择后的回调
    select(item) {
      console.log(item)
      this.region = item.sn
      this.equipment = item.equipment;
      this.show = false
      this.getDate();
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  font-size: 14px;
  background: #f5f7ff;
  .monitor {
    padding: 0 10px;
    height: 55px;
    line-height: 55px;
    background: #fff;
    vertical-align: middle;
    margin-bottom: 15px;
    position: relative;
    .monitor-img {
      width: 17px;
      height: 17px;
      vertical-align: middle;
    }
    .real-time {
      margin-left: 10px;
      color: #333;
      font-size: 16px;
      display: inline-block;
      vertical-align: middle;
      .span {
        width: 14px;
        height: 14px;
        background: #8992a9;
        border-radius: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 6px;
        text-align: center;
        line-height: 6px;
        img {
          width: 8px;
          height: 4px;
        }
      }
    }
    .data-analysis {
      position: absolute;
      width: 76px;
      height: 33px;
      line-height: 33px;
      background: #0e1526;
      text-align: center;
      opacity: 0.8;
      left: 40px;
      top: 40px;
      font-size: 12px;
      color:#fff;
    }
    .text {
      margin-left: 10px;
      color: #333;
      font-size: 16px;
      vertical-align: middle;
      display: inline-block;
    }
    .time {
      float: right;
      color: #656565;
      font-size: 12px;
    }
  }
  .pm {
    padding: 0 10px;
    .pm-list {
      .line {
        width: 4px;
        height: 12px;
        border-radius: 4px;
        display: inline-block;
      }
      .line-one {
        background: #e33f3f;
      }
      .line-two {
        background: #468bff;
      }
      .line-three {
        background: #6bc7a3;
      }
      .line-four {
        background: #867DFF;
      }
      .line-five {
        background: #FFA21C;
      }
      .line-six {
        background: #FF7460;
      }
      .title {
        font-weight: bold;
        font-size: 13px;
        margin-left: 8px;
        color: #333;
      }
      .bg-img {
        height: 125px;
        overflow: hidden;
        position: relative;
        margin-top: 15px;
        margin-bottom: 20px;
        .xg-content{
          position:absolute;
          left:210px;
          .title1{
            font-size: 17px;
            font-family: Arial;
            font-weight: bold;
            color: #546183;
          }
          .mt10{
            margin-top:10px;
          }
          .mt5{
            margin-top:5px;
          }
          .mt30{
            margin-top:30px;
          }
          .mt15{
            margin-top:15px;
          }
          .mt40{
            margin-top:54px;
          }
          .mt33{
            margin-top:38px;
          }
          .title2{
            background: #E7E7E7;
            border-radius: 3px;
            font-size: 10px;
            font-family: Source Han Sans CN;
            color: #546183;
            width:120px;
            height:20px;
            line-height:20px;
            padding:0 0 0 8px;
            overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          }
        }
        // .content {
        //   height: 35px;
        //   line-height: 35px;
        //   background: #536183;
        //   opacity: 0.8;
        //   position: absolute;
        //   bottom: 0;
        //   width: 86%;
        //   border-bottom-right-radius: 12px;
        //   border-bottom-left-radius: 12px;
        //   color: #fff;
        //   font-size: 14px;
        //   padding: 0 26px;
        //   .ml40 {
        //     margin-left: 40px;
        //   }
        // }
      }
      .bg-img-one {
        background: url("~@/assets/img/home/PM.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .bg-img-two {
        background: url("~@/assets/img/home/wind.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .bg-img-three {
        background: url("~@/assets/img/home/wind-direction.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .bg-img-four {
        background: url("~@/assets/img/home/temperature.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .bg-img-five {
        background: url("~@/assets/img/home/illumination.png") no-repeat center center;
        background-size: 100% 100%;
      }
       .bg-img-six {
        background: url("~@/assets/img/home/noise.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  .screen {
    padding: 0 10px;
    margin-bottom: 20px;
    .title {
      height: 30px;
      line-height: 30px;
      padding: 0 5px;
    }
    ul {
      width: 100%;
      background-color: #fff;
      border-radius: 4px;
      li {
        width: 95%;
        margin: 0 auto;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ccc;
        .content {
          display: inline-block;
          float: right;
          span {
            margin-right: 10px;
          }
        }
      }
      li:last-child {
        border: none;
      }
    }
  }
}
.my-enter-active {
	transition: all .5s ease;
}
.my-leave-active {
	transition: all .5s ease;
}
.my-enter,.my-leave-to{ 
  transform: translateY(10px);
  opacity: 0;
}
</style>
